import { useEffect, useState } from "react"
import useStore from "../../../store"
import { FaPlusCircle } from "react-icons/fa"
import Spinner from "../../common/Spinner"
import Pagination from "../../common/Pagination"
import ReusableDrawer from "../../common/ReusableDrawer"
import UnitNotesRow from "./UnitNotesRow"
import UnitNoteForm from "./UnitNoteForm"
import { Widget, WidgetHeader, WidgetBody } from "../../ui/Widget"

export default function UnitNotes({ unitId }) {
  const unitNotes = useStore((state) => state.unitNotes)
  const isFetchingUnitNotes = useStore((state) => state.isFetchingUnitNotes)
  const fetchUnitNotes = useStore((state) => state.fetchUnitNotes)
  const unitNotesPage = useStore((state) => state.unitNotesPage)
  const setUnitNotesPage = useStore((state) => state.setUnitNotesPage)
  const { currentPage, lastPage, dataTotal, totalPages } = useStore((state) => state.unitNotesPaginationData)

  const [isFormOpen, setIsFormOpen] = useState(false)

  useEffect(() => {
    fetchUnitNotes(unitId)
  }, [unitId, unitNotesPage])

  const handlePageClick = (event) => {
    setUnitNotesPage(event.selected + 1)
  }

  return (
    <Widget>
      <WidgetHeader
        title="Notes"
        showSpinner={isFetchingUnitNotes}
        actionIcon={
          <FaPlusCircle
            className="w-6 h-6 hover:cursor-pointer"
            onClick={() => setIsFormOpen(true)}
          />
        }
      />
      <WidgetBody>
        {isFetchingUnitNotes && !unitNotes.length ? (
          <div className="flex justify-center py-4">
            <Spinner />
          </div>
        ) : unitNotes.length > 0 ? (
          <>
            {unitNotes.map((note) => (
              <UnitNotesRow key={note.id} note={note} />
            ))}
            <Pagination
              currentPage={currentPage}
              lastPage={lastPage}
              dataTotal={dataTotal}
              handlePageClick={handlePageClick}
              totalPages={totalPages}
            />
          </>
        ) : (
          <p className="text-grey-300 p-4 text-center">No notes found.</p>
        )}
      </WidgetBody>
      <ReusableDrawer
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        title="New Note"
        placement="bottom"
        bodyContent={
          <UnitNoteForm unitId={unitId} onClose={() => setIsFormOpen(false)} />
        }
      />
    </Widget>
  )
}
